var _ellipse, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPattern(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 705,
    height: 696,
    viewBox: "0 0 705 696",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 347.213,
    cy: 352.091,
    rx: 347.213,
    ry: 352.091,
    transform: "matrix(-4.37114e-08 -1 0.99919 0.040241 0.725586 680.689)",
    fill: "url(#paint0_linear_660_6204)",
    fillOpacity: 0.9
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_660_6204",
    x1: 481.634,
    y1: 814.125,
    x2: 400.128,
    y2: -144.272,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4969D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.615399,
    stopColor: "#23389D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPattern);
export default __webpack_public_path__ + "static/media/pattern.5ce7b117a3950fd11f4a91a52b5bc253.svg";
export { ForwardRef as ReactComponent };